module.exports = "<canvas #canvas (mousedown)=\"onMouseDown($event)\" (mouseup)=\"onMouseUp($event)\">\r\n</canvas>"


//////////////////
// WEBPACK FOOTER
// C:/Users/s6ccq3/git/angular-three-examples/src/app/scene/scene.component.html
// module id = ../../../../../src/app/scene/scene.component.html
// module chunks = main